/**
 * Really should be called ProductType or something.
 */
export enum ServiceType {
    /**
     * Labor-Only: Standard
     */
    Standard = 1,
    /**
     * Labor-Only: Elite
     */
    Elite = 2,
    /**
     * Movers + Truck
     */
    MoversPlusTruck = 3,
    /**
     * Obsolete: Managed Labor: Hourly
     */
    ManagedLaborHourly = 11,
    /**
     * Managed Labor: Plus
     */
    ManagedLaborPlus = 12,
    /**
     * Corp Relo: LO
     */
    CorporateRelocation_LaborOnly = 14,
    /**
     * Corp Relo: LFS
     */
    CorporateRelocation_LocalFullService = 15,
    /**
     * Packing
     */
    Packing = 16,
    /**
     * Obsolete: Transport
     * @deprecated
     */
    Transport = 4,
    /**
     * Obsolete: Hybrid: ZS
     * @deprecated
     */
    HybridZS = 5,
    /**
     * Obsolete: Container
     * @deprecated
     */
    Container = 7,
    /**
     * Obsolete: Freight Trailer
     * @deprecated
     */
    FreightTrailer = 8,
    /**
     * Obsolete: Car Shipping
     * @deprecated
     */
    CarShipping = 9,
    /**
     * Obsolete: Truck Rental
     * @deprecated
     */
    TruckRental = 10,
    /**
     * Obsolete: Crating
     * @deprecated
     */
    Crating = 13,
}

const serviceTypeDescription = {
    Standard: 'Labor-Only: Standard',
    Elite: 'Labor-Only: Elite',
    MoversPlusTruck: 'Movers + Truck',
    ManagedLaborHourly: 'Managed: Hourly',
    ManagedLaborPlus: 'Managed: Plus',
    CorporateRelocation_LaborOnly: 'Corporate Relocation: Labor Only',
    CorporateRelocation_LocalFullService: 'Corporate Relocation: Local Full Service',
    Packing: 'Packing',
    Transport: 'Obsolete: Transport',
    HybridZS: 'Obsolete: Hybrid: ZS',
    Container: 'Obsolete: Container',
    FreightTrailer: 'Obsolete: Freight Trailer',
    CarShipping: 'Obsolete: Car Shipping',
    TruckRental: 'Obsolete: Truck Rental',
    Crating: 'Obsolete: Crating',
};

export const ServiceTypeDescription = {
    ...serviceTypeDescription,

    get: (value: ServiceType | undefined | null): string | undefined => {
        if (typeof (value) === "string") {
            return serviceTypeDescription[value];
        }
        if (value===null || value===undefined) {
            return undefined;
        }
        return serviceTypeDescription[ServiceType[value]  as keyof typeof serviceTypeDescription];
    },
    all: [
        { value: 1, label: serviceTypeDescription.Standard },
        { value: 2, label: serviceTypeDescription.Elite },
        { value: 3, label: serviceTypeDescription.MoversPlusTruck },
        { value: 11, label: serviceTypeDescription.ManagedLaborHourly },
        { value: 12, label: serviceTypeDescription.ManagedLaborPlus },
        { value: 14, label: serviceTypeDescription.CorporateRelocation_LaborOnly },
        { value: 15, label: serviceTypeDescription.CorporateRelocation_LocalFullService },
        { value: 16, label: serviceTypeDescription.Packing },
        { value: 4, label: serviceTypeDescription.Transport },
        { value: 5, label: serviceTypeDescription.HybridZS },
        { value: 7, label: serviceTypeDescription.Container },
        { value: 8, label: serviceTypeDescription.FreightTrailer },
        { value: 9, label: serviceTypeDescription.CarShipping },
        { value: 10, label: serviceTypeDescription.TruckRental },
        { value: 13, label: serviceTypeDescription.Crating },
    ] as ReadonlyArray<{label: string, value: number}>
};
